export default __webpack_public_path__ + "static/media/sticker-Z.74381cf7.png";